import React, { useState, useEffect } from "react";
import { API, UPLOADS } from "./../../config/api";
export default function Dashboard() {
  const [recentListings, setRecentListings] = useState([]);
  const [userName, setUserName] = useState("User");

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user) {
      setUserName(user.name);
      fetchDashboardData(user.id);
    }
  }, []);
  const [stats, setStats] = useState({
    machines_pending: 0,
    machines_active: 0,
    machines_hide: 0, // Added
    designers_pending: 0,
    designers_active: 0,
    workspace_pending: 0,
    workspace_active: 0,
    workspace_hide: 0, // Added
    machines_total: 0,
    designers_total: 0,
    workspace_total: 0,
  });
  const fetchDashboardData = async (userId) => {
    try {
      const res = await fetch(`${API.ADMIN_DASHBOARD}`);
      const data = await res.json();

      // Parse values safely
      const m_p = parseInt(data.machines_pending) || 0;
      const m_a = parseInt(data.machines_active) || 0;
      const m_h = parseInt(data.machines_hide) || 0; // This matches PHP "machines_hide"

      const w_p = parseInt(data.workspace_pending) || 0;
      const w_a = parseInt(data.workspace_active) || 0;
      const w_h = parseInt(data.workspace_hide) || 0; // This matches PHP "workspace_hide"

      const d_p = parseInt(data.designers_pending) || 0;
      const d_a = parseInt(data.designers_active) || 0;

      setStats({
        machines_pending: m_p,
        machines_active: m_a,
        machines_hide: m_h,
        machines_total: m_p + m_a + m_h,

        workspace_pending: w_p,
        workspace_active: w_a,
        workspace_hide: w_h,
        workspace_total: w_p + w_a + w_h,

        designers_pending: d_p,
        designers_active: d_a,
        designers_total: d_p + d_a,
      });
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };
  return (
    <div className="dashboard-content">
      <div className="page-header">
        <h2 className="machine-title">Dashboard</h2>
        <p>
          Welcome back, <strong>{userName}</strong>! Manage your listings
          easily.
        </p>
      </div>
      <h4>Machines</h4>
      <div className="dashboard-cards">
        {/* ================= MACHINES SECTION ================= */}
        <div className="card">
          <div className="card-icon blue">
            <i className="bi bi-gear"></i>
          </div>
          <div>
            <h4>{stats.machines_total}</h4>
            <p>Total Machines</p>
          </div>
        </div>
        <div className="card">
          <div className="card-icon blue">
            <i className="bi bi-gear"></i>
          </div>
          <div>
            <h4>{stats.machines_active}</h4>
            <p>Active Machines</p>
          </div>
        </div>
        <div className="card">
          <div className="card-icon blue">
            <i className="bi bi-gear"></i>
          </div>
          <div>
            <h4>{stats.machines_pending}</h4>
            <p>Pending Machines</p>
          </div>
        </div>
        {/* NEW: Hidden Machines */}
        <div className="card">
          <div className="card-icon blue">
            <i className="bi bi-eye-slash"></i>
          </div>
          <div>
            <h4>{stats.machines_hide}</h4>
            <p>Hidden Machines</p>
          </div>
        </div>
      </div>
      <h4>Workspaces</h4>
      <div className="dashboard-cards">
        {/* ================= WORKSPACE SECTION ================= */}

        <div className="card">
          <div className="card-icon orange">
            <i className="bi bi-building"></i>
          </div>
          <div>
            <h4>{stats.workspace_total}</h4>
            <p>Total Workspaces</p>
          </div>
        </div>
        <div className="card">
          <div className="card-icon orange">
            <i className="bi bi-building"></i>
          </div>
          <div>
            <h4>{stats.workspace_active}</h4>
            <p>Active Workspaces</p>
          </div>
        </div>
        <div className="card">
          <div className="card-icon orange">
            <i className="bi bi-building"></i>
          </div>
          <div>
            <h4>{stats.workspace_pending}</h4>
            <p>Pending Workspaces</p>
          </div>
        </div>
        {/* NEW: Hidden Workspaces */}
        <div className="card">
          <div className="card-icon orange">
            <i className="bi bi-eye-slash"></i>
          </div>
          <div>
            <h4>{stats.workspace_hide}</h4>
            <p>Hidden Workspaces</p>
          </div>
        </div>
      </div>{" "}
      <h4>Designers</h4>
      <div className="dashboard-cards">
        {/* ================= DESIGNERS SECTION ================= */}

        <div className="card">
          <div className="card-icon green">
            <i className="bi bi-palette"></i>
          </div>
          <div>
            <h4>{stats.designers_total}</h4>
            <p>Total Designers</p>
          </div>
        </div>
        <div className="card">
          <div className="card-icon green">
            <i className="bi bi-palette"></i>
          </div>
          <div>
            <h4>{stats.designers_active}</h4>
            <p>Active Designers</p>
          </div>
        </div>
        <div className="card">
          <div className="card-icon green">
            <i className="bi bi-palette"></i>
          </div>
          <div>
            <h4>{stats.designers_pending}</h4>
            <p>Pending Designers</p>
          </div>
        </div>
      </div>
    </div>
  );
}
